<template>
  <div class="main">
    <div class="select">
      <es-radio :label="'other'" v-model="paymentWay">&nbsp;</es-radio>
      <img src="@/assets/common/zfb.png" />
      <span>{{ $t('使用第三方支付') }}</span>
    </div>
    <div class="select">
      <es-radio :label="'Offline'" v-model="paymentWay">&nbsp;</es-radio>
      <img src="@/assets/common/offline.png" />
      <span>{{ $t('线下转账') }}</span>
      <i class="warning" @click="showTip"></i>
    </div>

    <div v-if="paymentWay == 'Offline'">
      <ul>
        <li>
          <span>{{ $t('公司名称') }}</span>
          <span>{{ $t('杭州天谷信息科技有限公司') }}</span>
        </li>
        <li>
          <span>{{ $t('税号') }}</span>
          <span>913301087458306077</span>
        </li>
        <li>
          <span>{{ $t('地址') }}</span>
          <span>{{ $t('浙江省杭州市西湖区西斗门路3号 天堂软件园D幢19层') }}</span>
        </li>
        <li>
          <span>{{ $t('电话') }}</span>
          <span>0571-88234700</span>
        </li>
        <li>
          <span>{{ $t('开户银行') }}</span>
          <span>{{ $t('平安银行杭州高新支行') }}</span>
        </li>
        <li>
          <span>{{ $t('银行账号') }}</span>
          <span>{{ transferInfo.bankAccountNo || '--' }}</span>
        </li>
      </ul>
    </div>

    <div class="footer">
      <h5Footer :invitationPrice="$route.query.invitationPrice" :text="$t(`确认支付`)" @click="pay()"></h5Footer>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { MessageBox } from 'mint-ui'
import 'mint-ui/lib/message-box/style.css'

export default {
  data() {
    return {
      paymentWay: 'other',
      transferInfo: {},
    }
  },
  components: {
    h5Footer: () => import('./components/footer'),
  },
  created() {
    this.getTransferInfo()
  },
  methods: {
    // 获取转账信息
    getTransferInfo() {
      this.$ajax(this.$url.getTransferInfo(this.$route.query.invitationId), {}).then((res) => {
        this.transferInfo = res.data || {}
      })
    },
    pay() {
      if (this.paymentWay === 'Offline') {
        this.offline()
      } else {
        this.aliPay()
      }
    },
    showTip() {
      MessageBox({
        title: $t('提示'),
        message: $t('您可以通过网银或柜台直接将相应金额转账至e签宝银行账户'),
      })
    },

    is_weixn() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return true
      }

      return false
    },

    async aliPay() {
      if (this.is_weixn()) {
        MessageBox({
          title: $t('提示'),
          message: $t('请用浏览器打开'),
        })

        return
      }
      const returnUrl = `${window.location.origin}/invitePaymentH5/result?invitationId=${this.$route.query.invitationId}`
      const thirdPayMode = 'ALIPAY_WAP'
      this.$ajax(this.$url.payInvitationspagePay(this.$route.query.invitationId), { returnUrl, thirdPayMode }, false)
        .then((res) => {
          const div = document.createElement('div')
          div.innerHTML = res.data // 此处form就是后台返回接收到的数据
          document.body.appendChild(div)
          document.forms[0].submit()
        })
        .catch((err) => {
          MessageBox.alert(err.message).then((action) => {
            window.location.href = 'https://www.esign.cn/'
          })
        })
    },
    // 线下支付
    offline() {
      this.$alert($t('请确认是否选择下线转账，确认后将不能线上支付，同时，也会完成邀请支付'), $t('提示'), {
        confirmButtonText: $t('确定'),
        cancelButtonText: $t('取消'),
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        showClose: true,
      }).then(() => {
        this.$ajax(this.$url.payByTransfer(this.$route.query.invitationId), {}, false)
          .then((res) => {
            this.$router.push({
              path: '/invitePaymentH5/result',
              query: {
                invitationId: this.$route.query.invitationId,
                isOffline: true,
              },
            })
          })
          .catch((err) => {
            MessageBox.alert(err.message).then((action) => {
              window.location.href = 'https://www.esign.cn/'
            })
          })
      })
    },
  },
}
</script>
<style lang="less" scoped>
.main {
  height: 100%;
  background: #f2f5f7;
  overflow: hidden;
}
.select {
  padding-left: 24px;
  height: 68px;
  line-height: 68px;
  background: rgba(255, 255, 255, 1);
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #1a1a1a;
  > img {
    width: 32px;
    height: 32px;
    margin-right: 20px;
  }
  i {
    font-size: 16px;
    margin-left: auto;
    margin-right: 20px;
  }
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
}
ul > li {
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 10px 24px;
  align-items: center;
  span:first-child {
    width: 150px;
  }
  span:last-child {
    width: 200px;
    text-align: right;
  }
}
.warning {
  background-image: url('../../../assets/icons/tip.png');
  width: 15px;
  height: 15px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
</style>
